import {useContext} from 'react'
import {CustomLanding36252Context} from '../../../../reducer'
import {Container} from './components/Container'
import {Heading} from './components/Heading'
import {t} from '../../../../i18n'
import {SocialLink} from '../SocialLink'
import {Row} from './components/Row'
import {ReactComponent as WindowsIcon} from '../../../../assets/windows.svg'
import {ShadowPlaceholder} from './components/ShadowPlaceholder'
import {ReactComponent as AppleIcon} from '../../../../assets/apple.svg'
import {ReactComponent as AndroidIcon} from '../../../../assets/android.svg'

export const Mt5Links = () => {
  const [state] = useContext(CustomLanding36252Context)
  return (
    <Container>
      <Heading>{t[state.language].downloadMt5}</Heading>
      <Row inverse={state.language === 'ar'}>
        <ShadowPlaceholder>
          <SocialLink href="https://download.mql5.com/cdn/web/inno.net.solutions/mt5/innonetsolutions5setup.exe" icon={<WindowsIcon />} />
        </ShadowPlaceholder>
        <ShadowPlaceholder>
          <SocialLink href="https://apps.apple.com/kw/app/metatrader-5/id413251709" icon={<AppleIcon />} />
        </ShadowPlaceholder>
        <ShadowPlaceholder>
          <SocialLink href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en" icon={<AndroidIcon />} />
        </ShadowPlaceholder>
      </Row>
    </Container>
  )
}
